import { render, staticRenderFns } from "./orderCreate.vue?vue&type=template&id=9cf5f1a6&scoped=true"
import script from "./orderCreate.vue?vue&type=script&lang=js"
export * from "./orderCreate.vue?vue&type=script&lang=js"
import style0 from "./orderCreate.vue?vue&type=style&index=0&id=9cf5f1a6&prod&lang=css"
import style1 from "./orderCreate.vue?vue&type=style&index=1&id=9cf5f1a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf5f1a6",
  null
  
)

export default component.exports